import React, { useState, useEffect } from 'react';
import { Snackbar, SnackbarContent, IconButton } from '@material-ui/core';
import { CheckCircle, Error, Warning, Info, Close } from '@material-ui/icons';

const CustomNotification = ({ message, type = 'info', duration = 4000, onClose }) => {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration]);

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      onClose && onClose();
    }, 300);
  };

  const getConfig = () => {
    switch (type) {
      case 'success':
        return {
          color: '#4caf50',
          icon: <CheckCircle />,
          message: message
        };
      case 'error':
        return {
          color: '#f44336',
          icon: <Error />,
          message: message
        };
      case 'warning':
        return {
          color: '#ff9800',
          icon: <Warning />,
          message: message
        };
      case 'info':
      default:
        return {
          color: '#2196f3',
          icon: <Info />,
          message: message
        };
    }
  };

  const config = getConfig();

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      style={{ 
        position: 'fixed',
        zIndex: 9999,
        bottom: '24px'
      }}
    >
      <SnackbarContent
        style={{
          backgroundColor: config.color,
          color: '#fff',
          minWidth: '300px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
        }}
        message={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ marginRight: '12px', display: 'flex', alignItems: 'center' }}>
              {config.icon}
            </div>
            <span>{config.message}</span>
          </div>
        }
        action={
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
            style={{ color: '#fff' }}
          >
            <Close />
          </IconButton>
        }
      />
    </Snackbar>
  );
};

export default CustomNotification;



// WEBPACK FOOTER //
// ./src/components/CustomNotification.js